const _UTILS = {
  async GetCartJS() {
    return fetch('/cart.js').then(res => res.json());
  },
  FormatMoney(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);    
  },
  async AddItemsToCart (items_to_add) {
    // items_to_add = [{
    //   quantity: qty,
    //   id: variant_id,
    //   selling_plan: selling_plan_id,
    //   properties: {}
    // }]
    return await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items_to_add })
    })
  },
  async UpdateCartItems(updates) {
    return await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    }).then(res => res.json());
  },
  async RefreshCart() {
    let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    let section_ids = cart.getSectionsToRender().map((section) => section.id);
    let sections = await fetch(`/?sections=${section_ids.join(',')}`).then(res => res.json());
    cart.renderContents({sections});
  }
}

document.addEventListener('alpine:init', () => {
  Alpine.store('cart', {
    cart: {
      items: [],
      item_count: 0,
      cart_level_discount_applications: []
    },
    async init() {
      let am = this;
      am.GetCart();
      subscribe(PUB_SUB_EVENTS.cartUpdate, am.GetCart.bind(am));
      document.addEventListener('store:update:cart', am.GetCart.bind(am));
    },
    async GetCart() {
      let cart = await _UTILS.GetCartJS();
      this.cart = {...cart};
      document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: this.cart}}));

      let $notify_elements = [...document.querySelectorAll('[data-notify-cart]')];
      $notify_elements.forEach(($el) => {
        $el.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: this.cart}}));
      });
    }
  });

  Alpine.data('CartProgressBars', () => ({
    cart: {
      items: [],
      total_price: 0
    },
    currency: '',
    money_format: '',
    flags: {
      is_AUD: true
    },
    pbars: {
      free_ship: {
        enabled: true,
        remaining: 0,
        threshold: 0,
        progress: 0,
        complete: false,
        show_message: true,
        position: '100%'
      },
      free_gift: {
        enabled: true,
        remaining: 0,
        threshold: 0,
        progress: 0,
        complete: false,
        show_message: false,
        variant_id: '',
        position: '100%'
      },
      progress: 0
    },
    init() {
      this.InitSelf();
      this.InitWatchers();
    },
    InitSelf() {
      let am = this;
      am.cart.total_price = parseFloat(am.$el.dataset.cart_total_price);
      am.currency = am.$el.dataset.currency;
      am.flags.is_AUD = am.currency == 'AUD';
      am.money_format = am.$el.dataset.money_format;
      am.pbars.free_ship.threshold = am.pbars.free_ship.remaining = parseFloat(am.$el.dataset.free_ship_threshold);
      am.pbars.free_gift.enabled = am.$el.dataset.free_gift_enabled == 'true';
      am.pbars.free_gift.threshold = am.pbars.free_gift.remaining = parseFloat(am.$el.dataset.free_gift_threshold);
      let free_gift_variants = JSON.parse(am.$el.dataset.free_gift_variants) || [];
      let free_gift_variant_sku = am.$el.dataset.free_gift_variant_sku || '';
      let free_gift_variant = free_gift_variants[0];
      if (free_gift_variant_sku) {
        free_gift_variant = free_gift_variants.find(v => v.sku == free_gift_variant_sku);
      }
      if (free_gift_variant) {
        am.pbars.free_gift.variant_id = free_gift_variant.id;
      }
      am.UpdateProgress();
    },
    InitWatchers() {
      let am = this;
      am.$el.addEventListener('cart:updated', Alpine.debounce((e) => {
        am.cart = {...e.detail.cart};
        am.UpdateProgress();
      }, 250));

      // set icons
      if (am.pbars.free_gift.enabled) {
        am.pbars.free_ship.position = '50%';
      }
    },
    UpdateProgress() {
      let am = this;

      let free_ship_remaining = am.pbars.free_ship.threshold - am.cart.total_price;
      let free_ship = {...am.pbars.free_ship};
      free_ship.progress = (am.cart.total_price / free_ship.threshold) * 100;
      free_ship.remaining = free_ship_remaining >= 0 ? free_ship_remaining : 0;
      free_ship.complete = free_ship.remaining <= 0;
      am.pbars.free_ship = {...free_ship};

      let free_gift_item_in_cart = am.cart.items.find((item) => item.variant_id == am.pbars.free_gift.variant_id && item.properties['_free_gift']);
      let free_gift_remaining = am.pbars.free_gift.threshold - am.cart.total_price;
      if (free_gift_item_in_cart) {
        free_gift_remaining += free_gift_item_in_cart.final_line_price;
      }
      let free_gift = {...am.pbars.free_gift};

      free_gift.progress = (am.cart.total_price / free_gift.threshold) * 100;
      free_gift.remaining = free_gift_remaining >= 0 ? free_gift_remaining : 0;
      free_gift.complete = free_gift.remaining <= 0;
      am.pbars.free_gift = {...free_gift};

      if (!am.pbars.free_gift.enabled) {
        am.pbars.progress = am.pbars.free_ship.progress;
      }

      if (am.pbars.free_gift.enabled && am.pbars.free_ship.enabled) {
        if (am.pbars.free_gift.enabled && !am.pbars.free_ship.complete) {
          am.pbars.progress = am.pbars.free_ship.progress / 2;
          am.pbars.free_gift.show_message = false;
        }
        if (am.pbars.free_gift.enabled && am.pbars.free_ship.complete) {
          am.pbars.progress = am.pbars.free_gift.progress;
          am.pbars.free_ship.show_message = false;
          am.pbars.free_gift.show_message = true;
        }  
      }

      if (am.pbars.free_gift.enabled && am.cart.items.length > 0) {
        if (am.pbars.free_gift.complete) {
          let is_in_cart = free_gift_item_in_cart !== undefined;
          if (am.pbars.free_gift.variant_id !== '' && !is_in_cart) {
            // console.log(is_in_cart, 'add freegift?!')
            let add_item = {
              id: am.pbars.free_gift.variant_id,
              quantity: 1,
              properties: {
                '_free_gift': true
              }
            };
            (async() => {
              await _UTILS.AddItemsToCart([add_item]);
              document.dispatchEvent(new CustomEvent('cart:modified'));
              _UTILS.RefreshCart();
            })();
          }
        }
        else {
          if (free_gift_item_in_cart) {
            (async() => {
              let remove_item = {};
              remove_item[free_gift_item_in_cart.key] = 0;
              await _UTILS.UpdateCartItems(remove_item);
              document.dispatchEvent(new CustomEvent('cart:modified'));
              _UTILS.RefreshCart();
            })();
          }
        }  
      }
    },
    FormatMoney(cents) {
      let formatted = _UTILS.FormatMoney(cents, this.money_format).replace('.00', '');
      return formatted;
    }
  }));

  Alpine.data('CartPackageProtection', () => ({
    enabled: false,
    package_variant_id: '',
    init() {
      this.InitSelf();
      this.InitWatchers();
    },
    InitSelf() {
      this.package_variant_id = this.$el.dataset.package_variant_id;
    },
    InitWatchers() {
      let am = this;
      document.addEventListener('cart:updated', am.CheckEnabled.bind(am));
      am.$watch('enabled', am.ToggleInsAddToCart.bind(am));
    },
    CheckEnabled() {
      let cart = this.$store.cart.cart;
      let is_in_cart = cart.items.some(item => item.variant_id == this.package_variant_id);
      this.enabled = is_in_cart;
    },
    async ToggleInsAddToCart() {
      let am = this;
      let update = {};
      update[am.package_variant_id] = am.enabled ? 1 : 0;
      await _UTILS.UpdateCartItems(update);
      document.dispatchEvent(new Event('store:update:cart'));
    },
  }));

  Alpine.data('BuyMore', () => ({
    message: '',
    init() {
      this.InitSelf();
      this.InitWatchers();
    },
    InitSelf() {
      let am = this;
      am.UpdateMessage();
    },
    InitWatchers() {
      let am = this;
      am.UpdateMessage();
      am.$el.addEventListener('cart:updated', am.UpdateMessage.bind(am));
    },
    UpdateMessage() {
      let am = this;
      let cart = Alpine.store('cart').cart;
      let items_minus_freegift = cart.items.filter((item) => !item.properties['_free_gift']);
      let count_items_minus_freegift = items_minus_freegift.reduce((sum, item) => sum + item.quantity, 0);
      // console.log({count_items_minus_freegift, count_items_minus_freegift});
      if (count_items_minus_freegift < 2) {
        am.message = `Add <strong>${2 - count_items_minus_freegift} more</strong> and <strong>Save 5%!</strong>`;
      }
      else if (count_items_minus_freegift < 4) {
        am.message = `Add <strong>${4 - count_items_minus_freegift} more</strong> and <strong>Save 10%!</strong>`;
      }
      else if (count_items_minus_freegift >= 4 && count_items_minus_freegift < 6) {
        am.message = `Add <strong>${6 - count_items_minus_freegift} more</strong> and <strong>Save 15%!</strong>`;
      }
      if (count_items_minus_freegift >= 6) {
        am.message = 'You\'re saving 15% on your order!';
      }
    }
  }));
});